import React, { useEffect, useMemo, useRef } from "react";
import styles from "./styles.module.scss";
import Switch from "../../../../../components/form/switch";
import {
  NOTIFICATION_CHANNELS,
  NOTIFICATION_CHANNELS_LABELS,
} from "../../constants";
import useUserStore, {
  updateUserNotificationSetting,
} from "../../../../../stores/user";

const EventItem = ({ event }) => {
  const abortController = useRef(null);
  const { id, name, description, recommended, key: eventKey } = event;
  const notificationSettings = useUserStore((s) => s.notificationSettings);
  const notificationSettingsLoading = useUserStore(
    (s) => s.notificationSettingsLoading,
  );
  const currentUserSetting = useMemo(() => {
    return notificationSettings?.find((s) => s.notification_event_id === id);
  }, [notificationSettings, id]);

  const handleChangeChannelSetting = (e, channel) => {
    abortController.current = new AbortController();
    updateUserNotificationSetting(
      {
        notification_event_id: id,
        [channel]: e.target.checked,
      },
      abortController.current,
    );
  };

  useEffect(() => {
    return () => {
      abortController.current?.abort();
    };
  }, []);

  return (
    <article className={styles.eventItem}>
      <div className={styles.eventItemDescription}>
        <h3 className={styles.heading}>
          {name}
          {Boolean(recommended) && (
            <span className={styles.recommended}> (Recommended)</span>
          )}
        </h3>
        <p className={styles.description}>{description}</p>
      </div>

      <div className={styles.eventItemSwitches}>
        {notificationSettingsLoading && null}
        {!notificationSettingsLoading &&
          Object.values(NOTIFICATION_CHANNELS).map((channel) => (
            <Switch
              key={`${eventKey}-${channel}`}
              id={`${eventKey}-${channel}`}
              name={`${eventKey}-${channel}`}
              label={NOTIFICATION_CHANNELS_LABELS[channel]}
              defaultChecked={
                currentUserSetting?.[channel] ?? event[`default_${channel}`]
              }
              onChange={(e) => handleChangeChannelSetting(e, channel)}
              labelPosition="left"
              labelSize="large"
              disabled={!event[`editable_${channel}`]}
              dimWhenDisabled
            />
          ))}
      </div>
    </article>
  );
};

export default EventItem;
